export const translations = {
  en: {
    nav_offers: "Offers",
    nav_why: "Why Cric1x",
    nav_join: "Join",
    admin: "Admin",
    hero_kicker: "India's Most Trusted Cricket Gaming Platform",
    hero_line1: "PLAY THE",
    hero_line2: "GAME.",
    hero_line3: "OWN THE ODDS.",
    hero_sub:
      "Live cricket action 24x7. Instant deposits, lightning withdrawals and the biggest bonuses in the game.",
    cta_whatsapp: "Join on WhatsApp",
    cta_website: "Visit Cric1x.com",
    cta_claim: "Spin & Claim Bonus",
    cta_join: "Join Now",
    hero_badge: "10% Weekly Loss Cashback",
    offer1_badge: "★ Biggest Offer",
    offers_kicker: "The Offers",
    offers_title: "STACKED IN YOUR FAVOUR",
    offer1_tag: "Weekly Cashback",
    offer1_value: "10%",
    offer1_desc: "Up to 10% loss-back credited to your wallet every single week. Play worry-free.",
    offer2_tag: "Welcome Bonus",
    offer2_value: "7%",
    offer2_desc: "A 7% boost on your very first deposit. Start big, win bigger.",
    offer_ends: "Welcome bonus ends in",
    offer3_tag: "Every Deposit",
    offer3_value: "5%",
    offer3_desc: "Get an extra 5% bonus on every top-up. No limits, no catches.",
    form_kicker: "60-Second Sign Up",
    form_title: "CLAIM YOUR BONUS",
    form_sub: "Drop your details and our team will activate your welcome package on WhatsApp instantly.",
    form_name: "Full Name",
    form_phone: "WhatsApp Number",
    form_submit: "Register & Claim",
    form_success: "You're in! Redirecting you to WhatsApp to activate your bonus...",
    form_error: "Please enter a valid name and 10-digit phone number.",
    why_title: "BUILT FOR WINNERS",
    why1_t: "Instant Withdrawals",
    why1_d: "Cash out in minutes, any time, any day.",
    why2_t: "100% Secure",
    why2_d: "SSL encrypted. Your data and money stay protected.",
    why3_t: "24/7 Support",
    why3_d: "Real humans on WhatsApp, whenever you need them.",
    why4_t: "Best Odds",
    why4_d: "Sharpest cricket markets across every big match.",
    trust_ssl: "SSL Encrypted",
    trust_secure: "Secure Payments",
    trust_support: "24/7 Support",
    pay_title: "Fast Deposits · Instant Withdrawals",
    footer_disclaimer:
      "Cric1x is for entertainment. 18+ only. Play responsibly. Gaming may be subject to local laws.",
    footer_rights: "All rights reserved.",
    lang_label: "हिंदी",
    marquee: "PLAY · PREDICT · WIN ·",
    spin_title: "SPIN TO WIN",
    spin_sub: "Try your luck — one free spin, guaranteed bonus.",
    spin_btn: "SPIN NOW",
    spin_won: "You won",
    spin_claim: "Claim on WhatsApp",
    admin_title: "Leads Dashboard",
    admin_login: "Enter admin password",
    admin_signin: "Sign In",
    admin_export: "Export CSV",
    admin_total: "Total Leads",
    admin_logout: "Logout",
  },
  hi: {
    nav_offers: "ऑफर",
    nav_why: "क्यों Cric1x",
    nav_join: "जॉइन",
    admin: "एडमिन",
    hero_kicker: "भारत का सबसे भरोसेमंद क्रिकेट गेमिंग प्लेटफॉर्म",
    hero_line1: "खेलो",
    hero_line2: "जीतो।",
    hero_line3: "बाज़ी पलटो।",
    hero_sub:
      "24x7 लाइव क्रिकेट एक्शन। इंस्टेंट डिपॉज़िट, तेज़ विदड्रॉल और सबसे बड़े बोनस।",
    cta_whatsapp: "WhatsApp पर जॉइन करें",
    cta_website: "Cric1x.com देखें",
    cta_claim: "स्पिन करें और बोनस पाएं",
    cta_join: "अभी जॉइन करें",
    hero_badge: "10% वीकली लॉस कैशबैक",
    offer1_badge: "★ सबसे बड़ा ऑफर",
    offers_kicker: "ऑफर",
    offers_title: "आपके फायदे में",
    offer1_tag: "वीकली कैशबैक",
    offer1_value: "10%",
    offer1_desc: "हर हफ्ते आपके वॉलेट में 10% तक लॉस-बैक। बेफिक्र होकर खेलें।",
    offer2_tag: "वेलकम बोनस",
    offer2_value: "7%",
    offer2_desc: "आपकी पहली डिपॉज़िट पर 7% बूस्ट। बड़ी शुरुआत, बड़ी जीत।",
    offer_ends: "वेलकम बोनस खत्म होने में",
    offer3_tag: "हर डिपॉज़िट",
    offer3_value: "5%",
    offer3_desc: "हर टॉप-अप पर एक्स्ट्रा 5% बोनस। कोई लिमिट नहीं, कोई शर्त नहीं।",
    form_kicker: "60 सेकंड में साइन अप",
    form_title: "अपना बोनस पाएं",
    form_sub: "अपनी डिटेल भरें, हमारी टीम तुरंत WhatsApp पर आपका वेलकम पैकेज एक्टिवेट करेगी।",
    form_name: "पूरा नाम",
    form_phone: "WhatsApp नंबर",
    form_submit: "रजिस्टर करें और पाएं",
    form_success: "हो गया! बोनस एक्टिवेट करने के लिए WhatsApp पर भेज रहे हैं...",
    form_error: "कृपया सही नाम और 10 अंकों का नंबर दर्ज करें।",
    why_title: "विनर्स के लिए बना",
    why1_t: "इंस्टेंट विदड्रॉल",
    why1_d: "किसी भी समय, मिनटों में पैसे निकालें।",
    why2_t: "100% सुरक्षित",
    why2_d: "SSL एन्क्रिप्टेड। आपका डेटा और पैसा सुरक्षित।",
    why3_t: "24/7 सपोर्ट",
    why3_d: "WhatsApp पर असली लोग, जब भी ज़रूरत हो।",
    why4_t: "बेस्ट ऑड्स",
    why4_d: "हर बड़े मैच पर सबसे शार्प क्रिकेट मार्केट।",
    trust_ssl: "SSL एन्क्रिप्टेड",
    trust_secure: "सुरक्षित पेमेंट",
    trust_support: "24/7 सपोर्ट",
    pay_title: "तेज़ डिपॉज़िट · इंस्टेंट विदड्रॉल",
    footer_disclaimer:
      "Cric1x मनोरंजन के लिए है। केवल 18+। ज़िम्मेदारी से खेलें। गेमिंग स्थानीय कानूनों के अधीन हो सकती है।",
    footer_rights: "सर्वाधिकार सुरक्षित।",
    lang_label: "EN",
    marquee: "खेलो · भविष्यवाणी · जीतो ·",
    spin_title: "स्पिन करो और जीतो",
    spin_sub: "किस्मत आज़माएं — एक फ्री स्पिन, गारंटीड बोनस।",
    spin_btn: "स्पिन करें",
    spin_won: "आपने जीता",
    spin_claim: "WhatsApp पर क्लेम करें",
    admin_title: "लीड्स डैशबोर्ड",
    admin_login: "एडमिन पासवर्ड डालें",
    admin_signin: "साइन इन",
    admin_export: "CSV एक्सपोर्ट",
    admin_total: "कुल लीड्स",
    admin_logout: "लॉगआउट",
  },
};

export const WHATSAPP_LINK = "https://wa.link/cric1x";
export const WEBSITE_LINK = "https://cric1x.com/";
export const getInitialLang = () => localStorage.getItem("cric1x_lang") || "en";
export const saveLang = (l) => localStorage.setItem("cric1x_lang", l);
